/**
 * Reusable shimmer skeletons for the 5 primary list surfaces.
 * Replace plain "Loading…" text in pages.
 */
import { Skeleton } from "@/components/ui/skeleton";

/** Vertical list of avatar rows — Matches, Inbox, Mentor sessions. */
export const ListRowSkeleton = ({ rows = 5 }: { rows?: number }) => (
  <ul className="space-y-3" aria-busy="true" aria-label="Loading">
    {Array.from({ length: rows }).map((_, i) => (
      <li
        key={i}
        className="flex items-center gap-4 rounded-2xl border border-border bg-card p-4"
      >
        <Skeleton className="h-14 w-14 flex-none rounded-xl" />
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
        <Skeleton className="h-8 w-20 rounded-full" />
      </li>
    ))}
  </ul>
);

/** Card grid — Mentors, Events. */
export const CardGridSkeleton = ({
  cards = 6,
  cols = 3,
}: {
  cards?: number;
  cols?: 2 | 3;
}) => (
  <div
    className={`grid gap-4 md:grid-cols-2 ${cols === 3 ? "lg:grid-cols-3" : ""}`}
    aria-busy="true"
    aria-label="Loading"
  >
    {Array.from({ length: cards }).map((_, i) => (
      <div
        key={i}
        className="overflow-hidden rounded-2xl border border-border bg-card"
      >
        <Skeleton className="aspect-[16/9] w-full rounded-none" />
        <div className="space-y-2 p-4">
          <Skeleton className="h-3 w-1/3" />
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      </div>
    ))}
  </div>
);

/** Discover swipe stack — single big card. */
export const SwipeCardSkeleton = () => (
  <div
    className="mx-auto w-full max-w-md overflow-hidden rounded-3xl border border-border bg-card"
    aria-busy="true"
    aria-label="Loading"
  >
    <Skeleton className="aspect-[3/4] w-full rounded-none" />
    <div className="space-y-2 p-5">
      <Skeleton className="h-6 w-2/3" />
      <Skeleton className="h-3 w-1/2" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  </div>
);
